export const COLLECTION_KEYS = {
  empresa: {
    trabajadores: {
      registros: "rm_f3a8_emp_tbs",
    },
  },
  rutogramas: {
    registros: "rm_b7d2_rtg",
  },
  seguridadVial: {
    conductores: {
      registros: "rm_c1e5_sv_cond",
      licencias: {
        registros: "rm_4f02_sv_cond_lic",
      },
      examenes: {
        registros: "rm_9d3a_sv_cond_exa",
      },
      capacitaciones: {
        registros: "rm_d7b4_sv_cond_cap",
      },
      revisiones: {
        registros: "rm_e6c8_sv_cond_rev",
      },
    },
    vehiculos: {
      registros: "rm_5e3c_sv_veh",
      kilometrajes: {
        registros: "rm_8b1d_sv_veh_km",
      },
      documentos: {
        registros: "rm_7c4e_sv_veh_doc",
      },
      revisiones: {
        registros: "rm_0f6b_sv_veh_rev",
      },
      mantenimientos: {
        registros: "rm_1b5f_sv_veh_mts"
      }
    },
    formatos: {
      registros: "rm_2d7e_sv_fmt",
    },
    inspecciones: {
      registros: "rm_3a9f_sv_ins",
      exentos: {
        registros: "rm_1a2f_sv_ins_ext",
      },
    },
    aptitudes: {
      registros: "rm_a2f9_sv_cond_apt",
    },
    planesDesplazamientos: {
      registros: "rm_6e5f_sv_pls_trs",
      reportes: {
        registros: "rm_4f1l_sv_pls_trs_rp",
      },
    },
  },
  paises: "rm_1c8b_ub_ps",
  departamentos: "rm_1c8b_ub_dps",
  ciudades: "rm_7f2c_ub_cds",
  modoSinConexion: "rm_a5b6_oflm",
  usuarios: {
    local: "rm_9e0d_us_lc",
  },
};
